import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider } from '@material-ui/core/styles';
import React, { Suspense, lazy, StrictMode } from "react";
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import reducers from './core/reducers';
import { getEnvVariable } from "./modules/environmentalList";
import ErrorHandler from './core/modules/ErrorHandler';
import { theme, laoacs_theme } from './material-theme';
import * as ReactDOM from "react-dom/client";

const store = createStore(reducers, applyMiddleware(thunk));

function component(id, classes) {
    var element = document.createElement('div');
    element.setAttribute("id", id);
    classes.forEach(e => element.classList.add(e))
    return element;
};


// console.log = () => { }
// console.debug = () => { }

function GetApp(moduleKey) {
    if (moduleKey === 'AMES')
        return lazy(() => import('./App_AMES'))
    else if (moduleKey === 'EPS')
        return lazy(() => import('./App_EPS'))
    else if (moduleKey === 'UPS')
        return lazy(() => import('./App_UPS'))
    else if (moduleKey === 'KEPT')
        return lazy(() => import('./App_KEPT'))
    else if (moduleKey === 'SAC')
        return lazy(() => import('./App_SAC'))
    else if (moduleKey === 'APS')
        return lazy(() => import('./App_APS'))
    else if (moduleKey === 'LAOACS')
        return lazy(() => import('./APP_LAOACS'))
}

function GetTheme(moduleKey) {
    if (moduleKey === 'LAOACS')
        return laoacs_theme
    else return theme
}

const MaterialTheme = GetTheme(getEnvVariable('ModuleKey'))
const App = GetApp(getEnvVariable('ModuleKey'));

// document.body.appendChild(component('root', ['h-100', 'of-auto']));
document.body.appendChild(component('ames-backdrop', ['ames-class']));
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("No root element found");
}

ReactDOM.createRoot(rootElement).render(
    <MuiThemeProvider theme={MaterialTheme}>
        <CssBaseline>
            <ErrorHandler>
                <Provider store={store}>
                    <Suspense fallback={<div ></div>}>
                        <StrictMode>
                            <App />
                        </StrictMode>
                    </Suspense>
                </Provider>
            </ErrorHandler>
        </CssBaseline>
    </MuiThemeProvider>
);



